/* eslint-disable perfectionist/sort-enums --
 * This is a special case where the enum is used to render frontend components.
 * therefor the keys are not sorted alphabetically but logically. */
export enum JournalEntryType {
    Subjectief = 'Subjectief',
    Objectief = 'Objectief',
    Evaluatie = 'Evaluatie',
    Plan = 'Plan',
}
/* eslint-enable perfectionist/sort-enums */
